import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useContext, useState } from 'react';
import { useTheme } from '@emotion/react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { getApiCall, postApiCall } from 'api/apiService';
import dashboardLogo from 'assets/icons/retrexlogo.png';
import keyicon from 'assets/images/keyicon.png';
import mailicon from 'assets/images/mailicon.png';
import ssl from 'assets/images/ssl.png';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import {
  AUDIO_FILES,
  Basename_url,
  BUYER_REVIEW,
  GETBUYER_SOLICITOR_BY_ID,
  GETUSER_DETAILS,
  LOGIN_URL,
} from 'constant/app.config';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { themePink } from 'theme/color';
import { paddTop10 } from 'theme/common.style';
import { validateEmail } from 'utils/validation.util';
import {
  forgotPasswordLink,
  loginButton,
  loginFootCopy,
  loginFooterCont,
  loginFootMessageDiv,
  loginFormHeader,
  loginFormHeadersm,
  loginFormMain,
  loginFormText,
  loginFormTextsm,
  loginHeadBtn,
  loginHeaderCont,
  loginHeadText,
  loginLabelEmail,
  loginMailDiv,
  loginPassCont,
  remberTextField,
} from './Login.style';
import Loading from 'assets/images/loading.png';
import ForgotPassword from 'modules/public/LoginPage/ForgotPassword';
import SendOTP from 'modules/public/LoginPage/SendOTP';
import ShowNewPassword from 'modules/public/LoginPage/ShowNewPassword';
import { activestatus } from 'api/rcpapiService';
import { ADMIN_ROUTES } from 'constant/admin.config';
import { setAdminSession } from 'utils/admin.auth.utils';

function LoginForm(props) {
  const history = useHistory();
  const { labelText, btnText, type } = props;
  const { setLoaderConfig } = useContext(LoaderContext);
  const [logLoader, setLogLoader] = useState(false);
  const [loggedin, setLoggedin] = useState(false);
  const [isexpired, setIsexpired] = useState('');

  useEffect(() => {
    const value = localStorage.getItem('isexpired');

    if (value) {
      setIsexpired(value);

      setTimeout(() => {
        // Remove it so refresh won't show it again
        localStorage.removeItem('isexpired');
      }, 200);
    }
  }, []);
  const theme = useTheme();
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const [lastSeenUser, setLastSeenUser] = useState('');
  const [token, setToken] = useState('');
  const [remember, setRemember] = useState(false);
  const [otpResponseObj, setotpResponseObj] = useState({});

  const updateFormValue = (fieldName, fieldPass, email) => {
    setFormValues((prevState) => ({
      ...prevState,
      [fieldName]: {
        ...prevState[fieldName],
        value: email, // Empty the value of the specified field
      },
      [fieldPass]: {
        ...prevState[fieldPass],
        value: '', // Empty the value of the specified field
      },
    }));
  };

  const updateFormValue1 = (fieldName, fieldPass) => {
    setFormValues((prevState) => ({
      ...prevState,
      [fieldName]: {
        ...prevState[fieldName],
        value: '', // Empty the value of the specified field
      },
      [fieldPass]: {
        ...prevState[fieldPass],
        value: '', // Empty the value of the specified field
      },
    }));
  };

  const [formValues, setFormValues] = useState({
    userEmail: {
      value: '',
      error: false,
      errorMessage: 'Please enter the email address',
    },
    userPassword: {
      value: '',
      error: false,
      errorMessage: 'Password is required',
      showPassword: false,
    },
  });

  useEffect(() => {
    let url = new URL(window.location.href);
    const searchParams = new URLSearchParams(window.location.search);
    const keyvalue = searchParams.get('logIn');
    if (url.searchParams.has('logIn')) {
      getApiCall(GETUSER_DETAILS + '/' + keyvalue).then((res) => {
        if (res?.data?.status == 1) {
          const updatedValue = res?.data?.details?.userEmail.toLowerCase();
          setFormValues({
            userEmail: {
              value: updatedValue,
              error: false,
              errorMessage: 'Please enter the email address',
            },
            userPassword: {
              value: '',
              error: false,
              errorMessage: 'Password is required',
              showPassword: false,
            },
          });
        }
      });
    }
  }, []);

  useEffect(() => {
    const remember = localStorage.getItem('remember');
    const rememberemail = localStorage.getItem('rememberemail');

    if (remember === 'true' && rememberemail) {
      setRemember(true);

      setFormValues((prev) => ({
        ...prev,
        userEmail: {
          ...prev.userEmail,
          value: rememberemail,
        },
        userPassword: {
          ...prev.userPassword,
          value: '',
        },
      }));
    } else {
      setRemember(false);
      updateFormValue1('userEmail', 'userPassword');
    }
  }, []);

  /** Toast options used by every failure message on this screen. */
  const errorToastOptions = {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    progress: 0,
    theme: 'light',
    style: { fontFamily: 'Poppins' },
  };

  const callLoginApi = () => {
    setLogLoader(true);
    const params = {
      value: formValues.userEmail.value,
      password: formValues.userPassword.value,
      loginFrom: matches500 ? 'Mobile' : 'Web',
    };
    try {
      postApiCall(LOGIN_URL, params)
        .then(async (res) => {
          if (res?.data?.status == '1') {
            localStorage.removeItem('isexpired');
            activestatus(true, res?.data?.moxoToken); // Set user as active on login (RCP)

            if (window.chmln && res?.data?.userId) {
              console.log('Calling Chameleon identify', res?.data?.userId);

              window.chmln.identify(String(res?.data?.userId), {
                email: res?.data?.userEmail,
                role: res?.data?.primaryUserType,
              });
            }

            await getApiCall(AUDIO_FILES).then(async (res) => {
              await localStorage.setItem(
                'audiofiles',
                JSON.stringify(res?.data)
              );
            });
            if (remember === true) {
              localStorage.setItem('rememberemail', formValues.userEmail.value);
              localStorage.setItem('remember', 'true');
            } else {
              localStorage.removeItem('rememberemail');
              localStorage.setItem('remember', 'false');
              setRemember(false);
            }

            await localStorage.setItem('isLoginLoading', 'true');
            let primaryUserTypeval = res?.data?.primaryUserType || '';
            await localStorage.setItem('isFirstLogin', res?.data?.isFirstLogin);
            await localStorage.setItem('isLogin', 'true');
            await localStorage.setItem('userDetail', JSON.stringify(res?.data));
            setLoggedin(true);
            await localStorage.setItem(
              'primaryUser',
              JSON.stringify(res?.data?.primaryUserType)
            );
            await localStorage.setItem(
              'userType',
              JSON.stringify(
                Array.isArray(res?.data?.userType)
                  ? res?.data?.userType[0]
                  : res?.data?.userType
              )
            );

            await localStorage.setItem('lastSeenUser', res?.data?.lastSeenUser);
            let lastSeenUser = await localStorage.getItem('lastSeenUser');
            setLastSeenUser(lastSeenUser);
            await localStorage.setItem(
              'token',
              res?.data?.token?.original?.token
            );
            await localStorage.setItem(
              'accesstoken',
              res?.data?.token?.original?.token
            );
            setLoaderConfig({ isVisible: true });

            const firstUserType = Array.isArray(res?.data?.userType)
              ? res?.data?.userType[0]?.userType || res?.data?.userType[0]
              : res?.data?.userType;

            const isAdminUser =
              primaryUserTypeval === 'Admin' || firstUserType === 'Admin';

            if (isAdminUser) {
              setAdminSession({
                adminId: res?.data?.userId || 'ADM-001',
                userName: res?.data?.userName || 'Admin',
                userSurName: res?.data?.userSurName || '',
                userEmail: res?.data?.userEmail || '',
                adminRole: res?.data?.adminRole || 'Admin',
                ...res?.data,
              });
            }

            if (res?.data?.primaryUserType == 'Buyer') {
              getApiCall(GETBUYER_SOLICITOR_BY_ID).then((res) => {
                if (res?.data?.status == 1) {
                  localStorage.setItem('buyerSolicitor', 'Yes');
                  localStorage.setItem(
                    'buyerSolicitorDetails',
                    JSON.stringify(res?.data?.data)
                  );
                } else {
                  localStorage.setItem('buyerSolicitor', 'No');
                }
              });
            }
            let token = await localStorage.getItem('token');
            setToken(token);
            localStorage.setItem(
              'moxoDetail',
              JSON.stringify(res?.data?.moxoToken)
            );
            localStorage.setItem(
              'moxoUserId',
              JSON.stringify(res?.data?.moxoUserId)
            );
            if (primaryUserTypeval.includes('Solicitor')) {
              setLoaderConfig({ isVisible: false });
              window.open(`${Basename_url}` + '/solicitor', '_self');
            } else if (primaryUserTypeval.includes('Buyer')) {
              getApiCall(BUYER_REVIEW).then((response) => {
                if (response?.data?.status == 1) {
                  if (response?.data?.propertyList?.length > 0) {
                    setLoaderConfig({ isVisible: false });
                    history.push('/Survey');
                  } else {
                    history.push('/');
                  }
                }
              });
            } else if (isAdminUser) {
              setLoaderConfig({ isVisible: false });
              history.push(ADMIN_ROUTES.dashboard);
            } else {
              history.push('/');
            }
          } else {
            toast.dismiss();
            toast.error(
              res?.data?.message ? res?.data?.message : 'Login Failed',
              {
                position: 'top-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                progress: 0,
                theme: 'light',
                style: {
                  fontFamily: 'Poppins',
                },
              }
            );
            setLogLoader(false);
            return;
          }
        })
        .catch((err) => setLogLoader(false));
    } catch (error) {
      setLogLoader(false);
    }
  };

  useEffect(() => {
    const dataType = JSON.parse(localStorage.getItem('userDetail') || '{}');
    if (loggedin) {
      window.usetifulTags = {
        userId: dataType?.userId,
        firstName: dataType?.userName || 'N/A',
        lastName: dataType?.userSurName || 'N/A',
        segment: dataType ? 'authenticated' : 'non-authenticated',
        role: dataType?.primaryUserType || 'user',
      };

      if (window.Usetiful) {
        const usetifulInstance = window.Usetiful.getInstance();
        usetifulInstance.loadConfig({
          token: 'a74ff9507fd1a757d216e4f49aeb1ec7',
        });
      } else {
        console.error('Usetiful is not defined.');
      }
    }
  }, [loggedin]);

  useEffect(() => {
    if (logLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [logLoader]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formValues.userEmail.value.trim() === '') {
      setFormValues((prevState) => ({
        ...prevState,
        userEmail: {
          ...prevState.userEmail,
          error: true,
        },
      }));
      return;
    }

    if (!validateEmail(formValues.userEmail.value)) {
      let triggerSubmit = true;
      const formFields = Object.keys(formValues);
      let newFormValues = { ...formValues };
      for (let index = 0; index < formFields.length; index++) {
        const currentField = formFields[index];
        const currentValue = formValues[currentField].value;
        if (currentValue === '') {
          triggerSubmit = false;
          newFormValues = {
            ...newFormValues,
            [currentField]: {
              ...newFormValues[currentField],
              error: true,
            },
          };
        }
      }
      setFormValues(newFormValues);
      if (triggerSubmit) {
        callLoginApi(newFormValues);
      }
    } else {
      setFormValues((prevState) => ({
        ...prevState,
        userEmail: {
          value: formValues.userEmail.value,
          error: true,
          errorMessage: 'Check the email address is valid',
        },
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (isexpired != '') {
      setIsexpired('');
    }

    // Only fix cursor for userEmail field
    if (name === 'userEmail') {
      const input = e.target;
      const selectionStart = input.selectionStart;
      const lowerCased = value.toLowerCase();

      setFormValues((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          value: lowerCased,
          error: false,
        },
      }));

      // Set cursor back after setting state
      requestAnimationFrame(() => {
        const inputEl = document.querySelector(`input[name="${name}"]`);
        if (
          inputEl &&
          typeof inputEl.setSelectionRange === 'function' &&
          inputEl.type === 'text'
        ) {
          inputEl.setSelectionRange(selectionStart, selectionStart);
        }
      });
    } else {
      setFormValues({
        ...formValues,
        [name]: {
          ...formValues[name],
          value,
          error: false,
        },
      });
    }
  };

  const handleClick = (typeHandle) => {
    switch (typeHandle) {
      case 'signup':
        history.push('/signup');
        break;
      case 'login':
        history.push('/login');
        setShowForgotPassword(false);
        setShowNewPassword(false);
        setShowsendOTP(false);
        break;
      default:
        history.push('/login');
        break;
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const [shownewpassword, setShowNewPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showsendOTP, setShowsendOTP] = useState(false);
  const handleForgotPasswordClick = (e) => {
    e.preventDefault();
    setShowForgotPassword(true);
  };

  const handleShowNewPassword = () => {
    setShowNewPassword(!shownewpassword);
  };
  return (
    <Grid
      contain
      sx={[
        loginFormMain,
        {
          backgroundSize: matchesmd ? '150% 220px' : '350px 170px',
          height: '100%',
          paddingLeft: matchesmd && '5%',
        },
      ]}
    >
      <Grid
        contain
        sx={[
          !matchesmd && loginFootMessageDiv,
          {
            height: '100%',
            //
          },
        ]}
        display={'flex'}
        justifyContent={matchesmd && 'center'}
        direction={'column'}
      >
        {matchesmd && (
          // Logo stays left-aligned, where the ADMIN button used to sit beside it.
          <Box sx={[loginHeaderCont, { textAlign: 'left' }]}>
            <img alt="Logo" src={dashboardLogo} />
          </Box>
        )}
        {!matchesmd && (
          <Box
            sx={[
              loginHeaderCont,
              {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '16px',
              },
            ]}
          >
            <Typography
              sx={[loginHeadText, { paddingRight: 0 }]}
              component="span"
            >
              {showForgotPassword || shownewpassword
                ? 'Already have an account?'
                : "Don't have an account?"}
            </Typography>
            <Button
              // variant="outlined"
              style={{ borderRadius: '0px' }}
              sx={loginHeadBtn}
              onClick={() => {
                if (showForgotPassword || shownewpassword) {
                  handleClick('login');
                } else {
                  handleClick(type);
                }
              }}
              disabled={logLoader}
            >
              {showForgotPassword || shownewpassword ? 'LOGIN' : 'SIGN UP'}
            </Button>
          </Box>
        )}
        <div
          style={{
            paddingLeft: matcheslg ? (matchesmd ? null : '5%') : '10%',
            // paddingTop: matchesmd && "20vh",

            height: matchesmd ? '60%' : '90%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: matchesmd && !matchessm && 'center',
          }}
        >
          <Box
            sx={{
              paddingBottom: showsendOTP ? '1em ' : matchessm ? '1em' : '3.5em',
            }}
            textAlign={matchesmd && 'left'}
          >
            <Typography sx={matchessm ? loginFormHeadersm : loginFormHeader}>
              {showsendOTP
                ? 'OTP Verification Password'
                : showForgotPassword
                ? 'Forgot Password?'
                : shownewpassword
                ? 'Reset Password'
                : !matchessm
                ? 'Log into retreX'
                : 'Login'}
            </Typography>
            <Typography
              component="p"
              sx={!matchessm ? loginFormText : loginFormTextsm}
            >
              {showsendOTP
                ? 'Please enter four digit OTP sent to your mobile'
                : showForgotPassword
                ? 'Please enter your email address. We will send you an OTP to reset your password.'
                : shownewpassword
                ? 'Please enter the new password'
                : 'Enter your login details below.'}
            </Typography>
          </Box>
          {showForgotPassword ? (
            <ForgotPassword
              setShowsendOTP={setShowsendOTP}
              showsendOTP={showsendOTP}
              shownewpassword={shownewpassword}
              setShowForgotPassword={setShowForgotPassword}
              handleShowNewPassword={handleShowNewPassword}
              setotpResponseObj={setotpResponseObj}
            />
          ) : showsendOTP ? (
            <SendOTP
              setShowsendOTP={setShowsendOTP}
              handleShowNewPassword={handleShowNewPassword}
            />
          ) : shownewpassword ? (
            <ShowNewPassword
              otpResponseObj={otpResponseObj}
              setShowForgotPassword={setShowForgotPassword}
              setShowsendOTP={setShowsendOTP}
              setShowNewPassword={setShowNewPassword}
            />
          ) : (
            <Box autoComplete="off" component={'form'} method="post">
              {isexpired != '' && (
                <Typography
                  sx={{
                    color: '#D32F2F',
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    fontWeight: 600,
                  }}
                >
                  {isexpired}
                </Typography>
              )}
              <Typography component="div" sx={loginMailDiv}>
                <Typography component="label" sx={loginLabelEmail}>
                  Email Address
                </Typography>
                <Typography
                  component="div"
                  sx={{ paddingTop: '10px', paddingRight: '5%' }}
                >
                  <TextField
                    autoFocus
                    error={formValues.userEmail.error}
                    variant="outlined"
                    // FormHelperTextProps={{ style: { fontSize: matchessm && "10px" } }}
                    size={matchessm ? 'small' : ''}
                    tabIndex={1}
                    sx={{
                      '.MuiFormHelperText-contained': {
                        margin: '0',
                      },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'rgba(0, 85, 255, 0.64)',
                        },
                      },
                      width: !matchessm ? '424px' : '100%',
                      background: 'transparent',
                      borderRadius: '5px',
                      color: '#000000',
                    }}
                    placeholder="name@Example:.com.au"
                    id="userEmail"
                    type="email"
                    name="userEmail"
                    value={formValues.userEmail.value}
                    inputProps={{
                      style: {
                        fontFamily: 'poppins',
                        textTransform: 'lowercase',
                      },
                    }}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      if (e.key === ' ') {
                        e.preventDefault();
                      }
                    }}
                    helperText={
                      formValues.userEmail.error && (
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: matchessm ? '10px' : '13px',
                            fontFamily: 'poppins',
                          }}
                        >
                          {formValues.userEmail.errorMessage}
                        </div>
                      )
                    }
                    InputProps={{
                      style: {
                        fontSize: matchessm ? '12px' : matchesmd ? '14px' : '',
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <img
                            alt="img"
                            src={mailicon}
                            style={{
                              background: 'transparent',
                              paddingRight: '10px',
                              borderRight: '1px solid black',
                              width: matchesmd ? '25px' : '40px',
                              height: matchesmd ? '20px' : '',
                            }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Typography>
              </Typography>
              <Typography component="div">
                <Typography
                  component="div"
                  sx={[
                    loginPassCont,
                    { width: !matches500 ? '424px' : '100%' },
                  ]}
                >
                  <Typography component="label" sx={loginLabelEmail}>
                    Password
                  </Typography>
                  <Typography
                    component="a"
                    href="#"
                    tabIndex={5}
                    sx={{
                      ...forgotPasswordLink,
                      fontSize: matchessm ? '12px' : '14px',
                    }}
                    style={{
                      textDecoration: 'none',
                      margin: matchessm ? '3px' : '0px',
                      marginRight: matchessm ? 18 : '',
                    }}
                    onClick={handleForgotPasswordClick}
                  >
                    Forgot your password?
                  </Typography>
                </Typography>

                <Typography
                  component="div"
                  sx={{ paddingTop: '10px', paddingRight: '5%' }}
                  width="100%"
                >
                  <TextField
                    error={formValues.userPassword.error}
                    variant="outlined"
                    autoComplete="off"
                    tabIndex={2}
                    size={matchessm ? 'small' : ''}
                    inputProps={{
                      style: {
                        fontFamily: 'poppins',
                        // textTransform: "lowercase",
                      },
                    }}
                    sx={{
                      // ...loginEmailCont,
                      fontSize: matchessm
                        ? '12px'
                        : matchesmd
                        ? '14px'
                        : '16px',
                      fontFamily: 'poppins !important',
                      fontStyle: 'normal !important',
                      borderRadius: '5px',
                      background: 'transparent',
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'rgba(0, 85, 255, 0.64)',
                        },
                      },
                      height: matchessm ? '35px' : '60px',
                      padding: matchessm ? '0px 0px 0px 0px' : '0px',
                      width: !matchessm ? '424px' : '100%',
                      '& .MuiInputBase-input::placeholder': {
                        fontSize: matchessm ? '16px' : '20px',
                        fontWeight: 'bold',
                        height: matchessm ? '82%' : '82%',
                      },
                    }}
                    name="userPassword"
                    id="userPassword"
                    placeholder="&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;"
                    type={
                      showPassword ? 'text' : 'password'
                      // formValues.userPassword.showPassword ? "text" : "password"
                    }
                    value={formValues.userPassword.value}
                    onKeyDown={(e) => {
                      if (e.key === ' ') {
                        e.preventDefault();
                      }
                    }}
                    onKeyUp={(e) => {
                      setFormValues({
                        ...formValues,
                        userPassword: {
                          ...formValues.userPassword,
                          error: false,
                        },
                      });
                    }}
                    helperText={
                      formValues.userPassword.error && (
                        <div
                          style={{
                            paddingTop: '0px',
                            fontWeight: 600,
                            fontSize: matchessm ? '10px' : '13px',
                            marginLeft: '-11px',
                            fontFamily: 'poppins',
                          }}
                        >
                          {formValues.userPassword.errorMessage}
                        </div>
                      )
                    }
                    onChange={handleChange}
                    InputProps={{
                      disableUnderline: true,
                      style: {
                        fontSize: matchessm ? '12px' : matchesmd ? '14px' : '',
                        fontFamily: 'poppins',
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <img
                            alt="key"
                            src={keyicon}
                            style={{
                              paddingRight: '6px',
                              borderRight: '1px solid black',
                              width: matchesmd ? '25px' : '40px',
                              height: matchesmd ? '20px' : '',
                            }}
                          />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          {/* {matchesmd && ( */}
                          <IconButton
                            onClick={toggleShowPassword}
                            tabIndex={-1}
                          >
                            {showPassword ? (
                              <VisibilityIcon
                                sx={{ color: 'rgba(0, 0, 0, 0.5)' }}
                              />
                            ) : (
                              <VisibilityOffIcon
                                sx={{ color: 'rgba(0, 0, 0, 0.5)' }}
                              />
                            )}
                          </IconButton>
                          {/* )} */}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Typography>
              </Typography>

              <FormControlLabel
                sx={{
                  ...remberTextField,
                  ...paddTop10,
                  marginLeft: '-25px',
                  marginTop: '5px',
                }}
                tabIndex={3}
                control={
                  <Checkbox
                    checked={remember}
                    onChange={(e) => setRemember(e.target.checked)}
                    value="remember"
                    disableFocusRipple
                    disableTouchRipple
                    disableRipple
                    disabled={logLoader}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: '14px',
                      color: '#737497',
                      marginTop: '3px',
                    }}
                  >
                    {' '}
                    Remember me
                  </Typography>
                }
              />
              <Typography
                component="div"
                sx={[
                  {
                    display: 'flex',
                    justifyContent: matchesmd
                      ? matchessm
                        ? 'right'
                        : 'center'
                      : 'left',
                    paddingTop: matchesmd ? '10px' : '10px',
                    paddingRight: '5%',
                    // position:matchesmd && "fixed", right:matchesmd && "10%"
                    width: '100%',
                  },
                ]}
              >
                <Button
                  onClick={handleSubmit}
                  tabIndex={4}
                  disabled={logLoader}
                  // variant="outlined"
                  sx={[
                    loginButton,
                    {
                      padding: matchessm ? '4px 30px' : '10px 50px',
                      textTransform: 'capitalize',
                    },
                  ]}
                  size="large"
                  type="submit"
                >
                  LOGIN
                </Button>
                {logLoader && (
                  <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
                    <img
                      alt="Logo"
                      src={Loading}
                      className="loaderImage"
                      style={{
                        height: '38px',
                        width: '38px',
                        marginTop: '5px',
                      }}
                    />
                  </Grid>
                )}
              </Typography>
            </Box>
          )}
        </div>

        {matchesmd && (
          <Box
            sx={{
              paddingRight: '0%',
              textAlign: 'center',
              width: '100%',
              paddingBottom: '50px',
            }}
          >
            <Typography
              component={'Box'}
              sx={{
                fontSize: matchessm ? '12px' : '16px',
                color: themePink,
                fontFamily: 'poppins',
                fontWeight: 300,
              }}
            >
              {showForgotPassword || showsendOTP || shownewpassword ? (
                <>
                  Already Have An Account? &nbsp;
                  <Typography
                    component="span"
                    sx={{
                      fontSize: matchessm ? '13px' : '16px',
                      color: themePink,
                      fontFamily: 'poppins',
                      fontWeight: 500,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                    onClick={() => handleClick('login')}
                  >
                    Login
                  </Typography>
                </>
              ) : (
                <>
                  Don't Have An Account?{' '}
                  <Typography
                    component="span"
                    sx={{
                      fontSize: matchessm ? '13px' : '16px',
                      color: themePink,
                      fontFamily: 'poppins',
                      fontWeight: 500,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                    onClick={() => handleClick('signup')}
                  >
                    Sign Up
                  </Typography>
                </>
              )}
            </Typography>
          </Box>
        )}

        {!matchesmd && (
          <Typography
            component="div"
            display={'flex'}
            alignItems={'end'}
            justifyContent={'right'}
            position={'fixed'}
            bottom={'0px'}
            right={'0px'}
          >
            <Box contain sx={loginFooterCont}>
              <Grid item sx={{ paddingBottom: '10px' }}>
                <img alt="Logo" src={ssl} />
              </Grid>
              <Grid item sx={loginFootCopy}>
                Copyright 2020-retreX pty Ltd.
              </Grid>
            </Box>
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}

LoginForm.propTypes = {};

export default LoginForm;
